import React from 'react';
import { Dropdown, TwoColumn } from '../inputs';
import useActiveHeirarchy from '../../utils/useActiveHeirarchy';
import { getSingleCompanyGroupAreaDropdown } from '../../utils/employeeDGPHelper';

export const HierarchySelector = ({
  onGroupChange,
  groupId,
  groupDisabled,
  onProjectChange,
  projectId,
  projectDisabled,
  alwaysShowGroupDropdown = false,
  alwaysShowProjectDropdown = false,
  groupRequired = true,
  alphabetize = false,
  multi = false,
  filteredGroupDropdown,
  filteredProjectDropdown,
  showFilteredMessage,
  noTwoColumn,
  groupTooltip,
  displayGroupTooltip,
  projectTooltip,
  displayProjectTooltip,
  showProject = true,
  excludeGroups,
  projectRequired = true,
  allowProjectClear,
  groupTouched,
  projectTouched,
  projectError,
  areaPlaceholder,
  filterForGroups,
  filterForAreas,
  groupBareValues = false,
  groupNotBound = false
}) => {
  const { activeCompany, activeGroup, activeProject } = useActiveHeirarchy();

  let groupDropdown =
    filteredGroupDropdown ?? getSingleCompanyGroupAreaDropdown(activeCompany);

  groupDropdown = groupDropdown?.filter(
    gd => !excludeGroups?.includes(gd.value)
  );

  if (filterForGroups)
    groupDropdown = groupDropdown?.filter(gd =>
      Array.isArray(filterForGroups)
        ? filterForGroups?.includes(gd.value)
        : gd._id === filterForGroups
    );

  let projectDropdown = [];

  if (multi) {
    let groups = [];
    if (activeGroup) {
      groups = [activeGroup._id];
    } else {
      groups = groupId ?? [];
    }

    groups.forEach(g => {
      let group = activeCompany?.groups?.find(l => l._id === g);
      if (!group) return;

      group.projects.forEach(project => {
        if (!project.isHidden)
          projectDropdown.push({
            value: project._id,
            label: `${group.name} - ${project.name}`
          });
      });
    });
  } else {
    const selectedGroup = activeCompany.groups.filter(
      group => group._id === activeGroup._id || group._id === groupId
    );

    if (selectedGroup.length > 0) {
      projectDropdown = selectedGroup[0].projects
        ?.filter(p => !p.isHidden)
        ?.map(project => {
          return {
            value: project._id,
            label: project.name
          };
        });
      if (projectDropdown.length && allowProjectClear)
        projectDropdown.unshift({ value: '', label: '      ' });
    }
  }

  let projectOptions = filteredProjectDropdown ?? projectDropdown;

  if (filterForAreas)
    projectOptions = (projectOptions || []).filter(p =>
      Array.isArray(filterForAreas)
        ? filterForAreas?.includes(p.value)
        : p.value === filterForAreas
    );

  const showProjectDropdown = alwaysShowProjectDropdown
    ? true
    : projectOptions?.length && showProject && (!activeProject || multi);

  const ddInfo = (
    <>
      {(!activeGroup || alwaysShowGroupDropdown) && (
        <Dropdown
          searchable
          options={groupDropdown}
          fieldLabel="Group or Establishment:"
          currentValue={groupId}
          onChange={onGroupChange}
          isRequired={groupRequired}
          disabled={groupDisabled || (activeGroup && !multi && !groupNotBound)}
          alphabetize={alphabetize}
          multi={multi}
          selectButtons={multi}
          touched={groupTouched}
          tooltip={groupTooltip}
          displayTooltip={displayGroupTooltip}
          bareValues={groupBareValues}
        />
      )}
      {showProjectDropdown ? (
        <Dropdown
          searchable
          options={projectOptions}
          fieldLabel="Area:"
          currentValue={projectId?.length ? projectId : null}
          onChange={onProjectChange}
          disabled={
            projectDisabled ||
            !projectDropdown.length ||
            (filteredProjectDropdown && !filteredProjectDropdown?.length) ||
            (activeProject && !multi)
          }
          placeholder={
            areaPlaceholder
              ? areaPlaceholder
              : activeGroup
                ? ''
                : !groupId?.length
                  ? 'Select a Group/Establishment'
                  : !filteredProjectDropdown?.length && showFilteredMessage
                    ? 'No Areas available for selection'
                    : !projectDropdown.length
                      ? 'No Areas in Group/Establishment'
                      : ''
          }
          alphabetize={alphabetize}
          multi={multi}
          selectButtons={multi}
          tooltip={projectTooltip}
          displayTooltip={displayProjectTooltip}
          isRequired={projectRequired}
          touched={projectTouched}
          errorMessage={projectError}
        />
      ) : null}
    </>
  );

  return noTwoColumn ? ddInfo : <TwoColumn>{ddInfo}</TwoColumn>;
};

export default HierarchySelector;
